<template>
<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">
		<Header2 :show-search-bar-pic="showHeader" login-style="loginStyle" :mobile-icon-style="mobileIconStyle" :show-list-icon="showListIcon"/>
		<div class="content">
			<div style="height:80px;"></div>
			<div class="enclosure">
				<div class="inner">
					<div class="left">
						<SideMenu />
					</div>
					<div class="right">
						<div class="caption">
							<span>{{$t('personCenter')}}</span><span class="arrow"><i class="iconfont icon-jiantou2"></i></span><span>{{$t('notice.title')}}</span>
						</div>
						<div class="notice-list">
							<div
								class="notice-item"
								v-for="item in list"
								:key="item.id"
								@click="openNotice(item)"
							>
								<div class="notice-item__title">{{ item.title }}</div>
								<div class="notice-item__time">{{ item.created_at }}</div>
							</div>
							<div class="notice-empty" v-if="!loading && list.length <= 0">
								{{ $t('notice.empty') }}
							</div>
							<div class="page-wrapper" v-if="pagination.total > 0">
								<el-pagination
									background
									layout="prev, pager, next"
									:total="pagination.total"
									v-model:current-page="pagination.current"
									v-model:page-size="pagination.pageSize"
									@current-change="fetchList"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
	import notice from './notice_controller';
	export default notice;
</script>

<style src="@/assets/css/my/setting.css" scoped></style>
<style src="@/assets/css/my/notice.css" scoped></style>
